import axios from "axios";

// Sur le domaine de production (lesvinsdubistroquet.com), l'API est appelée en même origine
// (évite les blocages de cookies tiers, notamment sur iPhone/Safari).
const envUrl = process.env.REACT_APP_BACKEND_URL;
const host = typeof window !== "undefined" ? window.location.host : "";
const sameOrigin = host.endsWith("lesvinsdubistroquet.com");

export const API = sameOrigin ? `${window.location.origin}/api` : `${envUrl}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Session persistante : si le jeton d'accès (15 min) a expiré, on le renouvelle
// silencieusement avec le jeton de session (1 an), puis on rejoue la requête.
// La déconnexion n'arrive que via le bouton « Déconnexion ».
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error?.config || {};
    const url = config.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/refresh");
    if (error?.response?.status === 401 && !config._retried && !isAuthCall) {
      config._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(config);
      } catch {
        // session réellement expirée
      }
    }
    return Promise.reject(error);
  }
);

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n ?? 0);

export function formatApiError(e, fallback = "Une erreur est survenue. Réessayez.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  return fallback;
}

export const CATEGORY_LABELS = {
  rouge: "Vins rouges",
  blanc: "Vins blancs",
  champagne: "Champagnes",
  coffret: "Coffrets cadeaux",
};

export const ORDER_STATUS = {
  nouvelle: { label: "Nouvelle", classes: "bg-[#F5EEDC] text-[#8C6D23] border border-[#C5A059]/40" },
  prete: { label: "Prête à retirer", classes: "bg-[#6B1226] text-[#FAF6F0]" },
  recuperee: { label: "Récupérée", classes: "bg-[#3F6212]/10 text-[#3F6212] border border-[#3F6212]/30" },
  annulee: { label: "Annulée", classes: "bg-stone-200 text-stone-500" },
};
